import React from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";

const MainContainer = styled(Box)(({ theme }) => ({
  background: "#000",
  display: "flex",
  flexDirection: "column",
  padding: "60px 24px",
  position: "relative",
  overflow: "hidden",

  "&::after": {
    content: '""',
    position: "absolute",
    width: "95%",
    height: "80%",
    left: "65%",
    top: "10%",
    bottom: "10%",
    transform: "translateX(-100%), translateY(-50%)",
    background:
      "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
    filter: "blur(100px)",
    //backdropFilter: "blur(500px)",
    zIndex: 0,
  },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  width: "100%", // Set to 95% width
  maxWidth: "1200px",
  margin: "0 auto",
  position: "relative",
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

;



const ParaVideoSection = ({ title, subTitle, data }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


  return (
    <MainContainer>
      <ContentContainer>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width={isMobile ? "100%" : "100%"}
          margin="0 auto"
        >
          {/* Header Section */}
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
            sx={{ width: { xs: "100%", md: "70%" } }}
            textAlign="center"
          >
            <Typography
              variant="h2"
              sx={{
                background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontSize: { xs: "24px", sm: "32px", md: "40px" },
                fontWeight: 700,
                mb: { xs: 2, md: 4 },
                textAlign: { xs: "left", md: "center" },
              }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                color: "#8C8CC2",
                fontSize: { xs: "16px", md: "18px" },
                lineHeight: 1.8,
                marginBottom: { xs: 5, md: 10 },
                textAlign: { xs: "left", md: "center" },
              }}
            >
              {subTitle}
            </Typography>
          </Box>

          {/* iENERGY Section */}
          <Box
            display="flex"
            flexDirection={{ xs: "column", md: "row" }}
            gap={4}
            width="100%"
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "flex-start" }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Box width={{ xs: "100%", md: "95%" }}>
                  <Typography
                    variant="h3"
                    sx={{
                      color: "white",
                      fontSize: { xs: "24px", md: "32px", },
                      fontWeight: 700,
                      mb: 3,
                    }}
                  >
                    {data?.title}
                  </Typography>
                  {data?.para?.map((text, index) => (
                    <Typography
                      key={index}
                      sx={{
                        color: "#8C8CC2",
                        fontSize: { xs: "16px", md: "18px" },
                        lineHeight: 1.8,
                        fontWeight: 400,
                        mb: 2, // Add spacing between paragraphs
                      }}
                    >
                      {text}
                    </Typography>
                  ))}
                  {data?.listItems &&
                    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", justifyContent: "space-around", gap: 2, ml: 2 }}>
                      {data?.listItems?.map((item, index) => (
                        <Box key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            color: "#8C8CC2",
                            fontSize: { xs: 14, md: 16 }
                          }}
                        >
                          <Typography sx={{ fontSize: { xs: 14, md: 16 } }}>•</Typography>
                          <Typography>{item}</Typography>
                        </Box>
                      ))}
                    </Box>
                  }

                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    position: "relative",
                    width: "80%",
                    height: { xs: "200px", sm: "350px", md: "400px" },
                    backgroundColor: "#000",
                    borderRadius: "18px",
                    float: "right",
                  }}
                >
                  {/* Video */}
                  <Box
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="metadata"
                    component="video"
                    src={data?.mediaUrl}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transform: "scaleX(-1)",
                      borderRadius: "18px",
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: { xs: "-60px", md: "-80px" },
                      left: { xs: "-60px", md: "-80px" },
                      zIndex: 10,
                    }}
                  >
                    <Box
                      component="img"
                      src={data?.imgeUrl}
                      alt="img"
                      sx={{
                        width: { xs: "100px", sm: "120px", md: "160px" },
                        height: "auto",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 20px rgba(0,0,0,0.3)",
                        border: "2px solid rgba(255, 255, 255, 0.2)",
                      }}
                    />
                  </Box>
                </Box>
              </Grid>

            </Grid>
          </Box>
        </Box>
      </ContentContainer>
    </MainContainer>
  );
};

export default ParaVideoSection;
